/* eslint-disable arrow-body-style */
import React from 'react'

const BaseDiv = ({ style, children }) => (
  <div style={style}>
    {children}
  </div>
)

const Section = ({
  renderElement,
  renderChildren,
  ...props,
}) => {
  return (
    renderElement(
      BaseDiv,
      { ...props, children: renderChildren() },
    )
  )
}

Section.propTypes = {}
Section.defaultProps = {}

export default Section



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/Section.js